exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-yellow-acient[data-v-5c1ffe6d] {\n  background-color: #FFFF00;\n}\n.yellow-acient[data-v-5c1ffe6d] {\n  color: #FFFF00;\n}\n", ""]);

// exports
